import React, { useEffect, useState, useRef } from "react";
import { Toast } from "primereact/toast";
import { Loading } from "../../../components/Loading/Loading";
import { DialogConfirm } from "../../../components/DialogService/DialogService";
import { FooterButtonCustomLabel } from "../../../components/FooterButton/FooterButton";
import { useHistory } from "react-router-dom";
import { dataUserSession } from "../../../utilities/dataSession";

//PAGE
import P103List from "./P103List";
//SERVICE
import { contractorOrderListService } from "../../../service/100/P103Service";
import ValidateService from "../../../components/ValidateService/ValidateService";

export default function P103() {
    const history = useHistory();
    const toast = useRef(null);
    const [dataTable, setDataTable] = useState([]);
    const [confirmDialog, setConfirmDialog] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errData, setErrData] = useState(null);

    useEffect(() => {
        onGetDataList();
    }, []);

    const onGetDataList = () => {
        setLoading(true);
        const req = {
            userId: dataUserSession().userId,
        };
        contractorOrderListService(req).then(
            (res) => {
                setLoading(false);

                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataTable(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const footerButton = () => {
        const confirm = () => {
            const { orderNo } = confirmDialog.data;
            //Go Page 104
            history.push({
                pathname: "/104",
                state: {
                    action: "NEW",
                    orderNo: orderNo,
                    requestNo: "",
                    form: "103",
                },
            });

            setConfirmDialog(false);
        };
        return <FooterButtonCustomLabel labelCon="ยืนยัน" lableCan="ยกเลิก" onClickOk={() => confirm()} onClickCancle={() => setConfirmDialog(false)} />;
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        {/* Begin list Table */}
                        <P103List dataTable={dataTable} setBillNotiDialog={setConfirmDialog} />
                        {/* End List Table */}
                    </div>
                </div>
                <DialogConfirm visible={confirmDialog.open} header="" modal footer={footerButton()} onHide={() => setConfirmDialog(false)} textContent="กดปุ่มยืนยัน เพื่อยืนยันการเปิดเป็นใบแจ้งฯหรือกดยกเลิก เพื่อยกเลิกการทำรายการ" />
            </div>
        </>
    );
}
